module.exports = __webpack_public_path__ + "img/loading.d7fbf9d.gif";